import { createElement as rc, useMemo } from 'react';
import { styled, MenuShellItem, fromTheme, View, Icon, nativeOnlyStyles, webOnlyStyles } from 'lib_ui-primitives';
import { useTheme } from 'styled-components';
import MenuContext from './MenuContext';

let LeftToRight = styled(View)`
    flex-direction: row;
    padding: ${fromTheme('menu', 'header', 'padding')};
    gap: ${fromTheme('menu', 'menuItem', 'iconTextGap')};
    color: ${fromTheme('menu', 'color')};
    align-items: center;
`;
LeftToRight.displayName = 'menuShellLeftToRight';

LeftToRight = webOnlyStyles(LeftToRight)`
  span {
        ${({ selectable, theme }) => (selectable ? fromTheme('menu', 'menuItem', 'defaultFont')({ theme }) : '')}
    }

    a {
        ${({ selectable, theme }) => (selectable ? fromTheme('menu', 'menuItem', 'defaultFont')({ theme }) : '')}
        color: ${fromTheme('menu', 'color')};
    }

    li {
        flex-grow: 1;
        padding-left: 0;
        padding-right: 0;
        align-items: stretch;
    }

    &:hover {
        background-color: ${({ selectable, theme }) =>
            selectable ? fromTheme('menu', 'menuItem', 'hoverBackgroundColor')({ theme }) : 'transparent'};
    }

`;

LeftToRight = nativeOnlyStyles(LeftToRight)`
    margin-left:  ${fromTheme('menu', 'native', 'shell', 'marginLeft')};
    padding-left: ${fromTheme('menu', 'native', 'paddingLeft')};    
`;

const styledIcon = nativeOnlyStyles(Icon)`
    padding-left: ${fromTheme('menu', 'native', 'shell', 'paddingLeft')};
`;

let StyledShellItem = styled(MenuShellItem).attrs({ name: 'menu-shell-item' })`
    flex-grow: 1;
    padding-left: 0;
    align-items: stretch;
`;
StyledShellItem.displayName = 'StyledShellItem';

export default function MenuShell(props) {
    const { hNode: { title, textSize, textWeight, iconName } = {}, children, actionPayload } = props || {};
    const theme = useTheme();
    const color = theme.menu.color;

    // Wrap children in MenuContext so they know they're inside a menu
    const contextValue = useMemo(() => ({
        isInsideMenu: true,
        actionPayload
    }), [actionPayload]);

    const wrappedChildren = rc(MenuContext.Provider, { value: contextValue }, children);

    return rc(
        LeftToRight,
        { selectable: !!iconName },
        iconName && rc(styledIcon, { name: iconName, size: 'md', children: iconName, color }),
        rc(StyledShellItem, { hNode: { title, textSize, textWeight }, children: wrappedChildren })
    );
}
